module.exports = __webpack_public_path__ + "static/media/SMDA_LOGO.3481cdef.png";